import { BulkCreateCompanyRedesignLayout } from "../bulk-create-redesign/BulkCreateCompanyRedesignLayout";
import { CompanyConfigRedesignScreen } from "../company-config-redesign";
import {
  useBulkCreateCompanyRedesignEnabled,
  useCompanyConfigRedesignEnabled,
} from "../hooks";
import { BulkCreateCompanyLayout } from "../layouts/BulkCreateCompanyLayout";
import {
  BulkCreateCompanyReviewScreen,
  BulkCreateCompanyScreen,
  CompanyConfigListScreen,
  CompanyConfigVersionsScreen,
  MaintainCompanyConfigScreen,
  RetireCompanyConfigScreen,
} from "../screens";

export function CompanyConfigCatalogueRoute() {
  const redesignEnabled = useCompanyConfigRedesignEnabled();

  return redesignEnabled ? (
    <CompanyConfigRedesignScreen />
  ) : (
    <CompanyConfigListScreen />
  );
}

export function MaintainCompanyConfigRoute() {
  const redesignEnabled = useCompanyConfigRedesignEnabled();

  return (
    <MaintainCompanyConfigScreen
      presentation={redesignEnabled ? "redesign" : "legacy"}
      cataloguePath="/onboarding"
    />
  );
}

export function CompanyConfigVersionsRoute() {
  const redesignEnabled = useCompanyConfigRedesignEnabled();

  return (
    <CompanyConfigVersionsScreen
      presentation={redesignEnabled ? "redesign" : "legacy"}
      configurationBasePath="/onboarding"
    />
  );
}

export function RetireCompanyConfigRoute() {
  const redesignEnabled = useCompanyConfigRedesignEnabled();

  return (
    <RetireCompanyConfigScreen
      presentation={redesignEnabled ? "redesign" : "legacy"}
      configurationBasePath="/onboarding"
    />
  );
}

export function BulkCreateCompanyExperienceLayout() {
  const redesignEnabled = useBulkCreateCompanyRedesignEnabled();

  return redesignEnabled ? (
    <BulkCreateCompanyRedesignLayout />
  ) : (
    <BulkCreateCompanyLayout />
  );
}

export function BulkCreateCompanyReviewRoute() {
  const redesignEnabled = useBulkCreateCompanyRedesignEnabled();

  return redesignEnabled ? (
    <BulkCreateCompanyScreen />
  ) : (
    <BulkCreateCompanyReviewScreen />
  );
}
